import React, { useState } from "react";
import { Row, Col, Tooltip } from "reactstrap";
import { ContactUsEnquiryInsert } from "../../api/contactUsService";
import "../../assets/css/footer.css";
import CommonToastContainer from "../../components/Common/CommonToastContainer";
import FullScreenLoader from "../../components/Common/Loader";

const Footer = () => {
    const [tooltipOpen, setTooltipOpen] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: ""
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [toasts, setToasts] = useState([]);

    const showToast = (toastData) => {
        setToasts(prev => [...prev, { id: Date.now(), ...toastData }]);
    };

    const removeToast = (id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    };

    const validate = (values) => {
        const errors = {};

        if (!values.name.trim()) {
            errors.name = "Please Enter Your Name";
        } else if (values.name.trim().length < 2) {
            errors.name = "Name must be at least 2 characters";
        }

        if (!values.email.trim()) {
            errors.email = "Please Enter Your Email Address";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
            errors.email = "Please Enter Valid Email Address";
        }

        if (!values.message.trim()) {
            errors.message = "Please Enter Message";
        }

        return errors;
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched(prev => ({ ...prev, [name]: true }));
        setErrors(validate(formData));
    };

    const toggleTooltip = (id) => {
        setTooltipOpen(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validate(formData);
        setErrors(validationErrors);
        setTouched({ name: true, email: true, message: true });
        if (Object.keys(validationErrors).length > 0) return;

        setLoading(true);

        const payload = {
            Name: formData.name.trim(),
            EmailID: formData.email.trim(),
            Message: formData.message.trim()
        };

        try {
            const result = await ContactUsEnquiryInsert(payload);
            const msgObj = result?.Message?.[0];

            if (msgObj?.ReturnCode === "1") {
                showToast({
                    title: "Success!",
                    message: msgObj?.ReturnMessage,
                    type: "success",
                });
                setFormData({ name: "", email: "", message: "" });
                setTouched({});
                setErrors({});
            } else {
                showToast({
                    title: "Error!",
                    message: msgObj?.ReturnMessage || "Unable to send message.",
                    type: "error",
                });
            }
        } catch {
            showToast({
                title: "Error!",
                message: "Something went wrong. Please try again later.",
                type: "error",
            });
        }
        setLoading(false);
    };

    return (
        <>
            {loading && <FullScreenLoader />}
            <div className="footer-wrapper">
                <footer className="text-dark pt-lg-5 px-3 footer-container">
                    <div className="top-section">
                        <Row className="pt-4">
                            <Col lg={4} md={6} className="mb-3">
                                <h6 className="text-uppercase fw-medium text-muted mb-3">Let's Do Business</h6>
                                <form>
                                    <Row className="p-0">
                                        <Col sm={6} className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm border-primary bg-transparent big-input"
                                                placeholder="Your Name"
                                                value={formData.name}
                                                name="name"
                                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                onBlur={handleBlur}
                                            />
                                            {touched.name && errors.name && (
                                                <small className="text-danger fs-6">{errors.name}</small>
                                            )}
                                        </Col>
                                        <Col sm={6} className="mb-3">
                                            <input
                                                type="email"
                                                className="form-control form-control-sm border-primary bg-transparent big-input"
                                                placeholder="example@email.com"
                                                value={formData.email}
                                                name="email"
                                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                                onBlur={handleBlur}
                                            />
                                            {touched.email && errors.email && (
                                                <small className="text-danger fs-6">{errors.email}</small>
                                            )}
                                        </Col>
                                    </Row>
                                    <div className="mb-3">
                                        <textarea
                                            className="form-control form-control-sm border-primary bg-transparent big-textarea"
                                            rows="5"
                                            placeholder="Your Message Here"
                                            value={formData.message}
                                            name="message"
                                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                            onBlur={handleBlur}
                                        />
                                        {touched.message && errors.message && (
                                            <small className="text-danger fs-6">{errors.message}</small>
                                        )}
                                    </div>
                                    <button
                                        type="button"
                                        className="primary-button fs-6 btn-sm"
                                        id="send-btn"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        {loading ? "Sending..." : "SEND MESSAGE"}
                                    </button>
                                </form>
                            </Col>

                            <Col lg={4} md={6} className="fs-6 footer-form">
                                <h6 className="text-uppercase fw-medium text-muted mb-3">Contact Us</h6>
                                <div className="mb-1">
                                    Contact Number: <a href="tel:+9102269760000" className="footer-contact text-dark">
                                        +91-022-69760000
                                    </a>
                                </div>
                                <div className="mb-3">
                                    WhatsApp Number: <a
                                        href="https://wa.me/919920807125" 
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="footer-contact text-dark">
                                        +91 99208 07125
                                    </a>
                                </div>
                                <div className="small fs-6">
                                    <div className="mb-1">
                                        <h6 className="text-uppercase fw-medium footer-sub-heading text-muted mb-3">VISIT US</h6>
                                    </div>
                                    <div className="mb-3">
                                        <a
                                            href="https://maps.app.goo.gl/1vmFcePTHDc8dhXD7?g_st=aw"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="footer-contact text-decoration-none text-dark"
                                        >
                                            <span>204, Brahans Business Centre,</span><br />
                                            <span>Mahakali Caves Road, Andheri East,</span><br />
                                            <span>Mumbai, Maharashtra - 400093</span>
                                        </a>
                                    </div>
                                </div>
                            </Col>

                            <Col lg={4} md={6} className="mb-lg-4">
                                <h6 className="text-uppercase fw-medium text-muted mb-3">Company Links</h6>
                                <div className="row">
                                    <Col sm={12}>
                                        <div className="small fs-6 text-black">
                                            <div className="mb-2"><a href="/" className="text-dark text-decoration-none">Home </a></div>
                                            <div className="mb-2"><a href="/about-us" className="text-dark text-decoration-none">About Us</a></div>                                           
                                            <div className="mb-2"><a href="/product-range" className="text-dark text-decoration-none">Products</a></div>
                                            <div className="mb-2"><a href="/services" className="text-dark text-decoration-none">Services</a></div>
                                            <div className="mb-2"><a href="/contact-us" className="text-dark text-decoration-none">Contact Us</a></div>
                                            <div className="mb-2"><a href="/terms-condition" className="text-dark text-decoration-none">Terms & conditions</a></div>
                                            <div className="mb-2"><a href="/privacy-policy" className="text-dark text-decoration-none">Privacy Policy</a></div>
                                            <div className="mb-2">
                                                <a
                                                    href="/assets/pdf/Ethical-Business-Policies.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-dark text-decoration-none"
                                                >
                                                    Midamas Jewels LLP Ethical Business Policies
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="border-bottom border-2">
                        <div className="container-fluid">
                            <Row className="align-items-center py-2">
                                <Col lg={6} md={6} xs={12} className="text-center text-md-start mb-2 mb-md-0 logo-footer">
                                    <a href="/" className="text-decoration-none">
                                        <img src="/assets/images/Logo/Logo_dark.png" className="logo-link" alt="logo" />
                                    </a>
                                </Col>
                                <Col lg={6} md={6} xs={12} className="text-center text-md-end">
                                    <div className="d-flex flex-column align-items-center align-items-md-end">
                                        <div className="fw-semibold mb-2 social-heading">
                                            Follow Us on Social Media
                                        </div>
                                        <div className="d-flex gap-1 justify-content-center justify-content-md-end">
                                            {/*<span*/}
                                            {/*    id="fb-tooltip"*/}
                                            {/*    className="social-icon social-facebook"*/}
                                            {/*    style={{ cursor: "not-allowed" }}*/}
                                            {/*>*/}
                                            {/*    <span></span>*/}
                                            {/*    <i className="bx bxl-facebook-square"></i>*/}
                                            {/*</span>*/}
                                            {/*<Tooltip*/}
                                            {/*    fade={false}*/}
                                            {/*    placement="bottom"*/}
                                            {/*    isOpen={!!tooltipOpen["fb-tooltip"]}*/}
                                            {/*    target="fb-tooltip"*/}
                                            {/*    toggle={() => toggleTooltip("fb-tooltip")}*/}
                                            {/*>*/}
                                            {/*    Available Soon*/}
                                            {/*</Tooltip>*/}
                                            <a
                                                href="https://www.instagram.com/meera_jewelleryhouse/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="social-icon social-instagram"
                                            >
                                                <span></span>
                                                <i className="bx bxl-instagram-alt"></i>
                                            </a>
                                            <a
                                                href="https://www.linkedin.com/company/meera-jewellery-house-llp"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="social-icon social-linkedin"
                                            >
                                                <span></span>
                                                <i className="bx bxl-linkedin-square"></i>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="row">
                        <Row className="py-3">
                            <Col className="text-start d-flex">
                                <div className="footer-bottom text-dark">
                                    &copy; 2025. Midamas. Built with
                                    <i className="bx bxs-heart text-danger mx-1"></i>
                                    by&nbsp;
                                    <a href="https://axoneit.com/" className="text-decoration-none text-dark fw-semibold" target="_blank" rel="noopener noreferrer">
                                        Axone Infotech India
                                    </a>.
                                    All Rights Reserved.
                                </div>
                            </Col>
                        </Row>
                    </div>
                </footer>
            </div>
            <CommonToastContainer
                toasts={toasts}
                removeToast={removeToast}
            />
        </>
    );
};

export default Footer;
